module.exports = __webpack_public_path__ + "img/iron-on.1bb5e3ee.jpg";